import type { UserResponse } from '@/common/api/client/types.gen'

export type MissingProfileField = 'email' | 'password'

type UserWithPasswordFlag = UserResponse & {
    has_password?: boolean | null
}

export const hasUserEmail = (me?: UserResponse | null): boolean => Boolean(me?.email?.trim())

export const hasVerifiedEmail = (me?: UserResponse | null): boolean =>
    hasUserEmail(me) && (me?.is_verified === true || Boolean(me?.email_verified_at))

export const hasUserPassword = (me?: UserResponse | null): boolean =>
    (me as UserWithPasswordFlag | null | undefined)?.has_password === true

export const isProfileComplete = (me?: UserResponse | null): boolean => hasUserEmail(me) && hasUserPassword(me)

export const getPrimaryMissingProfileField = (me?: UserResponse | null): MissingProfileField | null => {
    if (!hasUserEmail(me)) {
        return 'email'
    }

    if (!hasUserPassword(me)) {
        return 'password'
    }

    return null
}

export const getMissingProfileFields = (me?: UserResponse | null): MissingProfileField[] => {
    const primaryField = getPrimaryMissingProfileField(me)

    if (!primaryField) {
        return []
    }

    return [primaryField]
}

export const getIncompleteProfileMessage = (me?: UserResponse | null): string => {
    const field = getPrimaryMissingProfileField(me)

    if (field === 'email') {
        return 'Укажите email в профиле'
    }

    if (field === 'password') {
        return 'Укажите пароль в профиле'
    }

    return ''
}
